function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColoredLightning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.926,
    height: 80,
    viewBox: "0 0 50.926 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m66.1 79.09 9.1 7.382 3.992-6.936z",
    transform: "translate(-63.705 -55.615)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.015 86.451a.16.16 0 0 1-.1-.038l-9.091-7.382a.16.16 0 0 1-.047-.178.155.155 0 0 1 .15-.1l13.1.446a.16.16 0 0 1 .131.085.15.15 0 0 1 0 .155l-4 6.945a.178.178 0 0 1-.108.075zm-8.626-7.368 8.584 6.969 3.757-6.546z",
    transform: "translate(-63.529 -55.435)",
    style: {
      fill: "#512684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.39 116.827 8.377 7.128 5.076-7.645-13.454.517z",
    transform: "translate(-68.102 -75.357)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.587 123.949a.164.164 0 0 1-.1-.038l-8.377-7.128a.155.155 0 0 1-.047-.174.146.146 0 0 1 .141-.1l13.44-.509a.146.146 0 0 1 .146.08.16.16 0 0 1 0 .164l-5.072 7.636a.179.179 0 0 1-.113.07zm-7.987-7.142 7.931 6.748 4.813-7.241z",
    transform: "translate(-67.922 -75.192)",
    style: {
      fill: "#512684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.982 88.68 6.818 2.273-34.786 49.588-3.574-5.741z",
    transform: "translate(-75.024 -60.702)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.79 140.522a.174.174 0 0 1-.127-.075L87.09 134.7a.155.155 0 0 1 0-.174l31.542-46.118a.155.155 0 0 1 .178-.061l6.823 2.273a.164.164 0 0 1 .1.1.15.15 0 0 1 0 .141l-34.792 49.591a.164.164 0 0 1-.15.07zm-3.381-5.9 3.39 5.452 34.552-49.218-6.508-2.17z",
    transform: "translate(-74.824 -60.523)",
    style: {
      fill: "#512684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.453 93.074-34.576 49.283-.967-1.557 33.871-48.28z",
    transform: "translate(-77.925 -62.739)",
    style: {
      opacity: 0.39,
      fill: "#7e27e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.689 34.82 6.941 3.5-8.274 21.794H120.09z",
    transform: "translate(-92.342 -32.134)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.21 60.068h-10.288a.155.155 0 0 1-.131-.075.169.169 0 0 1 0-.15l11.6-25.292a.174.174 0 0 1 .089-.085.169.169 0 0 1 .127 0L138.531 38a.155.155 0 0 1 .075.2l-8.274 21.78a.155.155 0 0 1-.122.088zm-10.016-.319h9.9l8.19-21.554-6.668-3.353z",
    transform: "translate(-92.174 -31.94)",
    style: {
      fill: "#512684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.054 41.491-8.279 21.841h-1.545l8.176-22.672 1.648.831z",
    transform: "translate(-101.964 -35.232)",
    style: {
      opacity: 0.39,
      fill: "#7e27e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.267 45.864h-.061l-7.044-2.949a.16.16 0 1 1 .122-.291l7.044 2.944a.153.153 0 0 1-.061.3zm-1.578 4.161a.132.132 0 0 1-.061 0l-6.837-2.86a.16.16 0 1 1 .122-.291l6.837 2.86a.16.16 0 0 1 .085.207.164.164 0 0 1-.146.085zm-1.395 3.667a.127.127 0 0 1-.061 0l-6.762-2.818a.16.16 0 1 1 .122-.291l6.762 2.818a.155.155 0 0 1-.061.3zm-1.583 4.165h-.061l-6.626-2.794a.16.16 0 0 1-.085-.207.164.164 0 0 1 .211-.085l6.621 2.78a.164.164 0 0 1 .085.211.155.155 0 0 1-.146.094zm-1.587 4.184h-.061l-6.485-2.724a.16.16 0 0 1-.085-.207.15.15 0 0 1 .207-.085l6.49 2.7a.155.155 0 0 1 .085.211.15.15 0 0 1-.15.105zm9.152 8.495h-.061l-6.457-2.7a.155.155 0 0 1-.085-.207.16.16 0 0 1 .207-.085l6.457 2.7a.16.16 0 0 1-.061.305zm-2.611 3.714a.132.132 0 0 1-.061 0l-6.415-2.677a.16.16 0 0 1-.1-.15.155.155 0 0 1 .155-.16.145.145 0 0 1 .061 0l6.405 2.681a.16.16 0 0 1 .085.207.164.164 0 0 1-.127.1zm-2.31 3.287a.15.15 0 0 1-.061 0l-6.358-2.667a.15.15 0 0 1-.085-.207.16.16 0 0 1 .207-.085l6.358 2.672a.155.155 0 0 1 .089.207.16.16 0 0 1-.15.08zm-2.611 3.757a.132.132 0 0 1-.061 0l-6.311-2.644a.155.155 0 0 1-.085-.207.16.16 0 0 1 .207-.085L116.806 81a.16.16 0 0 1 .085.207.164.164 0 0 1-.146.087zm-2.625 3.724a.164.164 0 0 1-.066 0l-6.25-2.625a.15.15 0 0 1-.085-.207.16.16 0 0 1 .207-.085l6.255 2.625a.16.16 0 0 1 .085.207.164.164 0 0 1-.146.085zm-2.686 3.865a.132.132 0 0 1-.061 0l-6.2-2.6a.16.16 0 0 1-.085-.207.155.155 0 0 1 .207-.085l6.2 2.6a.15.15 0 0 1-.061.291zm-2.639 3.729a.145.145 0 0 1-.061 0l-6.156-2.578a.16.16 0 1 1 .122-.291l6.156 2.578a.15.15 0 0 1-.061.291zm-2.306 3.282a.145.145 0 0 1-.061 0l-6.1-2.555a.16.16 0 1 1 .122-.291l6.1 2.555a.15.15 0 0 1-.061.291zm-2.616 3.714a.146.146 0 0 1-.061 0l-6.058-2.536a.16.16 0 0 1-.085-.207.15.15 0 0 1 .207-.085l6.058 2.536a.15.15 0 0 1-.061.291zm-2.625 3.757a.145.145 0 0 1-.061 0l-6.053-2.536a.16.16 0 0 1 .117-.3h.05l6.006 2.517a.165.165 0 0 1-.061.315zm-2.893 4.118a.146.146 0 0 1-.061 0l-5.945-2.5a.16.16 0 1 1 .122-.291l5.945 2.5a.15.15 0 0 1-.061.291zm-2.62 3.738a.145.145 0 0 1-.061 0l-5.893-2.475a.164.164 0 0 1-.085-.211.16.16 0 0 1 .207-.085l5.898 2.48a.15.15 0 0 1-.061.291z",
    transform: "translate(-76.215 -36.261)",
    style: {
      fill: "#512684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.64 79.45 5.729 4.456",
    transform: "translate(-69.296 -55.806)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.21 83.9a.146.146 0 0 1-.094-.033l-5.734-4.461a.16.16 0 0 1 .193-.249l5.734 4.461a.16.16 0 0 1-.1.282z",
    transform: "translate(-69.137 -55.642)",
    style: {
      fill: "#512684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.48 117.74 4.1 3.48",
    transform: "translate(-73.454 -76.116)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.38 121.181a.141.141 0 0 1-.1-.038l-4.1-3.475a.16.16 0 1 1 .207-.239l4.095 3.475a.169.169 0 0 1-.1.277z",
    transform: "translate(-73.255 -75.922)",
    style: {
      fill: "#512684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.679 57.284S85.059 91 78.208 100.768c-.869 1.277-1.517 2.141-1.808 2.475-.531.648-.657-.634-.535-3.005.409-8.2 3.757-29.457 3.757-29.457H69.093l10.124-17.573-13.087-.47 9.26-23.245a146.306 146.306 0 0 1 23.01 1.62q1.094.178 2.184.38c.841.15 1.681.319 2.508.5L94.4 57.284z",
    transform: "translate(-63.721 -29.306)",
    style: {
      fill: "#ff0660"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 103.361a.268.268 0 0 1-.1 0c-.263-.1-.47-.573-.347-3.32.38-7.711 3.409-27.18 3.757-29.288H68.54l.136-.239 9.984-17.343-13.05-.471.085-.211L75 29.1h.108a147.244 147.244 0 0 1 23.01 1.62c.733.117 1.47.244 2.188.38s1.611.305 2.512.5l.174.038-8.643 25.28H107.7l-.164.244c-.225.338-22.7 33.81-29.476 43.489-.939 1.352-1.536 2.165-1.794 2.484a.5.5 0 0 1-.366.226zm-6.82-32.947h10.472l-.028.183c-.033.211-3.362 21.343-3.757 29.439-.136 2.6.085 2.958.141 3.005a.61.61 0 0 0 .108-.108c.254-.31.841-1.118 1.784-2.465 6.462-9.218 27.236-40.131 29.3-43.23H93.9l8.685-25.338c-.826-.178-1.592-.329-2.324-.47s-1.456-.263-2.184-.38a147.78 147.78 0 0 0-22.855-1.62l-9.147 22.99 13.148.47z",
    transform: "translate(-63.445 -29.1)",
    style: {
      fill: "#512684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.629 52.816a.23.23 0 0 1-.1 0 .249.249 0 0 1-.131-.324l8.4-19.408a.255.255 0 1 1 .47.2l-8.41 19.4a.254.254 0 0 1-.225.131z",
    transform: "translate(-66.505 -31.13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.23 43.691 3.616 1.977-3.616 1.972-1.972 3.616-1.977-3.616-3.611-1.972 3.611-1.977 1.977-3.611z",
    transform: "translate(-61.355 -34.924)",
    style: {
      fill: "#7e27e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.9 51.22-2.092-3.82L61 45.317l3.822-2.094 2.095-3.823 2.066 3.813 3.832 2.1-3.832 2.087zm-5.264-5.9 3.4 1.878v.038l1.848 3.364 1.878-3.4h.038l3.362-1.878-3.4-1.878V43.4l-1.836-3.358-1.878 3.4h-.042z",
    transform: "translate(-61 -34.563)",
    style: {
      fill: "#512684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.569 110.485H77.46a.254.254 0 0 1-.216-.122.249.249 0 0 1 0-.244l2-3.677a.249.249 0 0 1 .333-.1.254.254 0 0 1 .1.338l-1.8 3.287h3.7a.249.249 0 1 1 0 .5z",
    transform: "translate(-69.599 -70.054)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.863 66.733 5.35-14.869.3.108-5.35 14.869z",
    transform: "translate(-107.073 -41.174)",
    style: {
      fill: "#512684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.915 148.319 3.794 2.076-3.794 2.076-2.076 3.794-2.076-3.794-3.794-2.076 3.794-2.076 2.076-3.8z",
    transform: "translate(-88.565 -90.32)",
    style: {
      fill: "#b06dfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.289 154.616-2.193-4.01-4.01-2.207 4.01-2.193 2.193-4.015 2.193 4.015 4.01 2.193-4.01 2.193zm-5.541-6.216 3.583 1.958v.042l1.935 3.536 1.958-3.578h.042l3.541-1.935-3.583-1.958v-.042l-1.935-3.541-1.958 3.583h-.042zm-14.981 12.244 2.066-19.86.318.033-2.066 19.86z",
    transform: "translate(-72.015 -88.339)",
    style: {
      fill: "#512684"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.383 121.717a.244.244 0 0 1-.136-.042.254.254 0 0 1-.07-.347l15.257-22.869a.249.249 0 0 1 .343-.066.244.244 0 0 1 .07.343L103.589 121.6a.254.254 0 0 1-.207.113zm-5.142 7.565a.282.282 0 0 1-.131-.038.254.254 0 0 1-.08-.343l3.4-5.461a.249.249 0 0 1 .343-.08.254.254 0 0 1 .08.343l-3.381 5.475a.249.249 0 0 1-.231.104z",
    transform: "translate(-80.622 -65.832)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredLightning);
export default __webpack_public_path__ + "static/media/colored-lightning.9237c2b1.svg";
export { ForwardRef as ReactComponent };